import {
  isIdealPlansFetchFailed,
  isIdealPlansLoading,
  useLumpsumPlansContext
} from './LumpsumPlansProvider'
import { IdealPlansListErrorState } from './body/ideal/IdealPlansListErrorState'
import { LumpsumIdealBody } from './body/ideal/LumpsumIdealBody'
import { LumpsumPlansFooter } from './footer/LumpsumPlansFooter'
import { PlansListChrome } from './header/common/PlansListChrome'
import { LumpsumIdealContextBar } from './header/ideal/LumpsumIdealContextBar'
import {
  LumpsumIdealHeader,
  resolveIdealHeaderAppearance
} from './header/ideal/LumpsumIdealHeader'
import { PlansCategoryListSkeleton } from './lumpsum-ui-components/PlansCategoryListSkeleton'
import { IdealTimerPanel } from './timer/ideal/IdealTimerPanel'
import { isPlanRolledOut } from './timer/shared/planStatus'
import { PlansPlanMode } from '../api/types'

/** Ideal tab: timer/strategy shell vs normal plan slots. */
export function IdealPageContent() {
  const { idealData, idealPlansQuery, refetchAllPlansQueries, markTimerResumeRefetch } =
    useLumpsumPlansContext()
  const chromeBackground = resolveIdealHeaderAppearance(idealData?.riskProfile).chromeBackground

  if (isIdealPlansLoading(PlansPlanMode.IDEAL_PORTFOLIO, idealData != null, idealPlansQuery)) {
    return (
      <>
        <PlansListChrome background={chromeBackground}>
          <LumpsumIdealHeader />
        </PlansListChrome>
        <PlansCategoryListSkeleton />
      </>
    )
  }

  if (isIdealPlansFetchFailed(PlansPlanMode.IDEAL_PORTFOLIO, idealPlansQuery)) {
    return <IdealPlansListErrorState onRetry={idealPlansQuery.refetch} />
  }

  if (!isPlanRolledOut(idealData?.planStatus)) {
    return (
      <IdealTimerPanel
        planStatus={idealData?.planStatus}
        timeToPlanDrop={idealData?.timeToPlanDrop}
        isSubscriptionEligible={idealData?.isPlanSubscriptionEligible === true}
        strategyCta={idealData?.strategyCta}
        refetchPlan={() => {
          markTimerResumeRefetch()
          refetchAllPlansQueries()
        }}
      />
    )
  }

  return (
    <>
      <PlansListChrome background={chromeBackground}>
        <LumpsumIdealHeader />
        <LumpsumIdealContextBar />
      </PlansListChrome>
      <LumpsumIdealBody />
      <LumpsumPlansFooter />
    </>
  )
}
